import { Model } from '@vuex-orm/core'
import { NumberField } from 'vuex-orm-decorators'

export default class AbstractModel extends Model {
  @NumberField()
  public id: number
}
